// extracted by mini-css-extract-plugin
module.exports = {"SInlineImage":"InlineImage_SInlineImage__BZ9_G","portrait":"InlineImage_portrait__S3_eE","SFigure":"InlineImage_SFigure__sXJFU","SFigcaption":"InlineImage_SFigcaption__1xhGG"};